import { render, staticRenderFns } from "./ledger-detail.vue?vue&type=template&id=036e482f&"
import script from "./ledger-detail.vue?vue&type=script&lang=js&"
export * from "./ledger-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports